import { render } from "./section-two.vue?vue&type=template&id=4d260a16&scoped=true"
const script = {}

import "./section-two.vue?vue&type=style&index=0&id=4d260a16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d260a16"]])

export default __exports__